import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Github, Twitter, Mail } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: 'Tools',
      links: [
        { name: 'QR Code Studio', path: '/tools/qr-code-studio' },
        { name: 'Steganography', path: '/tools/steganography' },
        { name: 'Encryption', path: '/tools/encryption' },
        { name: 'Metadata Remover', path: '/tools/metadata-remover' },
      ],
    },
    {
      title: 'Company',
      links: [
        { name: 'About Us', path: '/about' },
        { name: 'Contact', path: '/contact' },
        { name: 'Explore All Tools', path: '/explore' },
      ],
    },
    {
      title: 'Legal',
      links: [
        { name: 'Privacy Policy', path: '/privacy' },
        { name: 'Terms of Service', path: '/terms' },
        { name: 'Disclaimer', path: '/disclaimer' },
      ],
    },
  ];

  return (
    <footer className="border-t border-border/50 bg-card/30 backdrop-blur-md">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center space-x-2 group mb-4">
              <div className="p-2 glass-card rounded-lg group-hover:glow-primary transition-smooth">
                <Shield className="w-6 h-6 text-primary" />
              </div>
              <span className="text-xl font-bold gradient-text">
                NoTrackTools
              </span>
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-sm mb-4">
              Privacy-first security tools. All operations run locally in your browser.
              <span className="block mt-2 font-semibold text-foreground">
                Your data never leaves your device.
              </span>
            </p>
            <div className="flex space-x-3">
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 glass-card rounded-lg hover:glow-primary transition-smooth"
              >
                <Github className="w-5 h-5" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 glass-card rounded-lg hover:glow-primary transition-smooth"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <Link
                to="/contact"
                className="p-2 glass-card rounded-lg hover:glow-primary transition-smooth"
              >
                <Mail className="w-5 h-5" />
              </Link>
            </div>
          </div>

          {/* Links Sections */}
          {footerSections.map((section) => (
            <div key={section.title}>
              <h3 className="font-semibold text-foreground mb-4">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-muted-foreground hover:text-primary transition-smooth"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border/50">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-muted-foreground">
              © {currentYear} NoTrackTools. All rights reserved.
            </p>
            <p className="text-xs text-muted-foreground text-center md:text-right max-w-md">
              Built with privacy in mind. No tracking, no storage, no compromises.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
